import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions";
import * as API from "../api";
import Helper from "../../helpers/helpers";




export function* loadVendingCategory() {
  
  yield takeEvery(actionTypes.LOAD_VENDING_CATEGORY, function*(action) {

    if(!action.data) action.data = {}
    
    let search = (action.data.search) ? action.data.search : ""
    
    let track_no = Helper.generateTrackNo(`VENDINGCATEGORYLIST${search}`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadVendingCategory(action.data);
      if (response.data.success && response.data.data) {
   
        yield put(actions.loadVendingCategorySuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadVendingCategoryFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadVendingCategoryFail());
    }
  });
}

export function* loadVendingCategoryAll() {
  
  yield takeEvery(actionTypes.LOAD_VENDING_CATEGORY_ALL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGCATEGORYALL");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadVendingCategory(action.data);
      if (response.data.success && response.data.data) {
   
        yield put(actions.loadVendingCategoryAllSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadVendingCategoryAllFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadVendingCategoryAllFail());
    }
  });
}


export function* addVendingCategory() {
  yield takeEvery(actionTypes.ADD_VENDING_CATEGORY, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("ADDVENDINGCATEGORY");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.addVendingCategory(action.data);
      if (response.data.success) {
        yield put(actions.addVendingCategorySuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.addVendingCategoryFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.addVendingCategoryFail());
    }
  });
}

export function* editVendingCategory() {
  yield takeEvery(actionTypes.EDIT_VENDING_CATEGORY, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITVENDINGCATEGORY");

    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editVendingCategory(action.id,action.data);
      if (response.data.success) {
        yield put(actions.editVendingCategorySuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.editVendingCategoryFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editVendingCategoryFail());
    }
  });
}

export function* deleteVendingCategory() {
  yield takeEvery(actionTypes.DELETE_VENDING_CATEGORY, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DELETEVENDINGCATEGORY");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.deleteVendingCategory(action.id, action.data);
      if (response.data.success) {
        yield put(actions.deleteVendingCategorySuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.deleteVendingCategoryFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.deleteVendingCategoryFail());
    }
  });
}



export function* loadVendingCategoryEffectiveDateList() {
  
  yield takeEvery(actionTypes.LOAD_VENDING_PRICE_EFFECTIVE_DATE_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGEFFECTIVEDATELIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadVendingCategoryEffectiveDateList(action.data);
      if (response.data.success && response.data.data) {
       
        yield put(actions.loadVendingCategoryEffectiveDateListSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadVendingCategoryEffectiveDateListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadVendingCategoryEffectiveDateListFail());
    }
  });
}


export function* vendingCategoryPriceControlLoad() {
  yield takeEvery(actionTypes.VENDING_CATEGORY_PRICE_CONTROL_LOAD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGPRICECONTROLLOAD");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingCategoryPriceControlLoad(action.data);
      if (response.data.success) {

        yield put(actions.vendingCategoryPriceControlLoadSuccess(response.data.data));
        
      } else {
        alert(response.data.message);
        yield put(actions.vendingCategoryPriceControlLoadFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingCategoryPriceControlLoadFail());
    }
  });
}



export function* vendingCategoryPriceControlSet() {
  yield takeEvery(actionTypes.VENDING_CATEGORY_PRICE_CONTROL_SET, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETVENDINGPRICE");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingCategoryPriceControlSet(action.id, action.data);
      if (response.data.success) {
        yield put(actions.vendingCategoryPriceControlSetSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.vendingCategoryPriceControlSetFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingCategoryPriceControlSetFail());
    }
  });
}


export function* vendingCategoryPriceRemove() {
  yield takeEvery(actionTypes.DELETE_VENDING_CATEGORY_PRICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DELVENDINGPRICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingCategoryPriceRemove(action.id, action.data);
      
      if (response.data.success) {
        
        if(response.data.data)
        {
          yield put(actions.vendingCategoryPriceRemoveSuccess(response.data.data));

        }else{
   
          yield put(actions.vendingCategoryPriceRemoveSuccess());
          yield put(actions.toastSuccess(response.data.message));
        }
        
      } else {
        alert(response.data.message);
        yield put(actions.vendingCategoryPriceRemoveFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingCategoryPriceRemoveFail());
    }
  });
}

export function* getVendingCategoryPricePDF() {
  
  yield takeEvery(actionTypes.GET_VENDING_CATEGORY_PRICE_PDF, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GETVENDINGPRICEPDF");
    action.data.track_no = track_no


    yield put(actions.enableLoading());
    try {
      const response = yield API.getVendingCategoryPricePDF(action.data);
  
      if (response.data.success && response.data.data) {
        
        yield put(actions.getVendingCategoryPricePDFSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getVendingCategoryPricePDFFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.getVendingCategoryPricePDFFail());
    }
  });
}


export function* graderVendingCount() {
  yield takeEvery(actionTypes.GRADER_VENDING_COUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.graderVendingCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.graderVendingCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.graderVendingCountFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.graderVendingCountFail());
    }
  });
}

export function* loadGraderVendingList() {
  yield takeEvery(actionTypes.GRADER_VENDING_LIST, function*(action) {

    if(!action.data) action.data = {}
    let search = (action.data.search) ? action.data.search : ""
    let status = (action.data.status) ? action.data.status : ""
    let service_state = (action.data.service_state) ? action.data.service_state : ""

    let track_no = Helper.generateTrackNo(`GRADERVENDINGLIST${status}${search}${service_state}`);
    
    action.data.track_no = track_no
    
    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGraderVendingList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadGraderVendingListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGraderVendingListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGraderVendingListFail());
    }
  });
}

export function* loadGraderVendingLocationList() {
  yield takeEvery(actionTypes.GRADER_VENDING_LOCATION_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo(`GRADERVENDINGLOCATION`);
    
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGraderVendingLocationList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadGraderVendingLocationListSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGraderVendingLocationListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGraderVendingLocationListFail());
    }
  });
}

export function* loadGraderVendingBagList() {
  yield takeEvery(actionTypes.GRADER_VENDING_BAG_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo(`GRADERVENDINGBAG`);
    
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadGraderVendingBagList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadGraderVendingBagListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadGraderVendingBagListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadGraderVendingBagListFail());
    }
  });
}

export function* vendingBagCount() {
  yield takeEvery(actionTypes.GRADER_VENDING_BAG_COUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGBAGCOUNT");
    action.data.track_no = track_no

    try {
      const response = yield API.vendingBagCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.vendingBagCountSuccess(response.data.data));
      } else {
        yield put(actions.vendingBagCountFail());
      }
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.vendingBagCountFail());
    }
  });
}

export function* vendingBagRollbackOverflow() {
  yield takeEvery(actionTypes.GRADER_VENDING_BAG_ROLLBACK_OVERFLOW, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGBAGROLLBACKOVERFLOW");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingBagRollbackOverflow(action.id, action.data);
      if (response.data.success) {
        yield put(actions.vendingBagRollbackOverflowSuccess());

        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.vendingBagRollbackOverflowFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingBagRollbackOverflowFail());
    }
  });
}

export function* vendingBagConfirmTripFilling() {
  yield takeEvery(actionTypes.GRADER_VENDING_BAG_CONFIRM_TRIP_FILLING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGBAGCONFIRMTRIPFILLING");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingBagConfirmTripFilling(action.id, action.data);
      if (response.data.success) {
        yield put(actions.vendingBagConfirmTripFillingSuccess());

        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.vendingBagConfirmTripFillingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingBagConfirmTripFillingFail());
    }
  });
}

export function* vendingBagForceTripFilling() {
  yield takeEvery(actionTypes.GRADER_VENDING_BAG_FORCE_TRIP_FILLING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGBAGFORCETRIPFILLING");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingBagForceTripFilling(action.id, action.data);
      if (response.data.success) {
        yield put(actions.vendingBagForceTripFillingSuccess());

        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.vendingBagForceTripFillingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingBagForceTripFillingFail());
    }
  });
}

export function* graderVendingDeviceStatusList() {
  yield takeEvery(actionTypes.GRADER_VENDING_DEVICE_STATUS_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo(`GRADERVENDINGDEVICESTATUS`);
    
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.graderVendingDeviceStatusList(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.graderVendingDeviceStatusListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.graderVendingDeviceStatusListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.graderVendingDeviceStatusListFail());
    }
  });
}

export function* graderVendingUploadedLogsList() {
  yield takeEvery(actionTypes.GRADER_VENDING_UPLOADED_LOGS_LIST, function*(action) {

    if(!action.data) action.data = {}
    let search = (action.data.search) ? action.data.search : ""
    let level = (action.data.level) ? action.data.level : ""
    let status = (action.data.status) ? action.data.status : ""
    let offset = (action.data.offset) ? action.data.offset : ""

    let track_no = Helper.generateTrackNo(`GRADERVENDINGLOGS${search}${level}${status}${offset}`);
    
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.graderVendingUploadedLogsList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.graderVendingUploadedLogsListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.graderVendingUploadedLogsListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.graderVendingUploadedLogsListFail());
    }
  });
}

export function* errorLogsResolved() {
  yield takeEvery(actionTypes.ERROR_LOG_RESOLVED, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("ERRORLOGRESOLVED");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.errorLogsResolved(action.id, action.data);
      if (response.data.success) {
        yield put(actions.errorLogsResolvedSuccess());
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.errorLogsResolvedFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.errorLogsResolvedFail());
    }
  });
}

export function* graderVendingDetail() {
  yield takeEvery(actionTypes.GRADER_VENDING_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo(`GRADERVENDINGDETAIL`);
    
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.graderVendingDetail(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.graderVendingDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.graderVendingDetailFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.graderVendingDetailFail());
    }
  });
}

export function* approveGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_APPROVE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGAPPROVE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.approveGraderVending(action.id, action.data);
      if (response.data.success) {
        yield put(actions.approveGraderVendingSuccess());
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.approveGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.approveGraderVendingFail());
    }
  });
}

export function* addGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_CREATE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGCREATE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.addGraderVending(action.grader, action.data);
      if (response.data.success) {
        yield put(actions.addGraderVendingSuccess());
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.addGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.addGraderVendingFail());
    }
  });
}

export function* editGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_EDIT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGEDIT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editGraderVending(action.id, action.grader, action.data);
      if (response.data.success) {
        yield put(actions.editGraderVendingSuccess());
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.editGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editGraderVendingFail());
    }
  });
}

export function* resetPwdGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_RESET_PWD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGRESETPWD");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.resetPwdGraderVending(action.id, action.grader, action.data);
      if (response.data.success) {
        yield put(actions.resetPwdGraderVendingSuccess());
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.resetPwdGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.resetPwdGraderVendingFail());
    }
  });
}

export function* deleteGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_REMOVE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGREMOVE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.deleteGraderVending(action.id, action.grader, action.data);
      if (response.data.success) {
        yield put(actions.deleteGraderVendingSuccess());
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.deleteGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.deleteGraderVendingFail());
    }
  });
}


export function* publishGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_PUBLISH, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGPUBLISH");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.publishGraderVending(action.id, action.grader, action.data);
      if (response.data.success) {
        yield put(actions.publishGraderVendingSuccess());

        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.publishGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.publishGraderVendingFail());
    }
  });
}

export function* residentOnlyGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_RESIDENT_ONLY, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGRESIDENTONLY");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.residentOnlyGraderVending(action.id, action.grader, action.data);
      if (response.data.success) {
        yield put(actions.residentOnlyGraderVendingSuccess());

        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.residentOnlyGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.residentOnlyGraderVendingFail());
    }
  });
}


export function* rebootGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_REBOOT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGREBOOT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.rebootGraderVending(action.id, action.data);
      if (response.data.success) {
        yield put(actions.rebootGraderVendingSuccess());
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.rebootGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.rebootGraderVendingFail());
    }
  });
}

export function* unlockMaglockGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_UNLOCK_MAGLOCK, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGUNLOCKMAGLOCK");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.unlockMaglockGraderVending(action.id, action.data);
      if (response.data.success) {
        yield put(actions.unlockMaglockGraderVendingSuccess());

        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.unlockMaglockGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.unlockMaglockGraderVendingFail());
    }
  });
}

export function* currentStatusGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_CURRENT_STATUS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGCURRENTSTATUS");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.currentStatusGraderVending(action.id, action.data);
      if (response.data.success) {
        yield put(actions.currentStatusGraderVendingSuccess());

        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.currentStatusGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.currentStatusGraderVendingFail());
    }
  });
}

export function* controlBoardGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_CONTROL_BOARD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGCONTROLBOARD");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.controlBoardGraderVending(action.id, action.command, action.data);
      if (response.data.success) {
        yield put(actions.controlBoardGraderVendingSuccess());

        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.controlBoardGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.controlBoardGraderVendingFail());
    }
  });
}

export function* stopGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_STOP_SERVICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGSTOPSERVICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.stopGraderVending(action.id, action.data);
      if (response.data.success) {
        yield put(actions.stopGraderVendingSuccess());
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.stopGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.stopGraderVendingFail());
    }
  });
}

export function* startGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_START_SERVICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGSTARTSERVICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.startGraderVending(action.id, action.data);
      if (response.data.success) {
        yield put(actions.startGraderVendingSuccess());
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.startGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.startGraderVendingFail());
    }
  });
}

export function* testConnectionGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_TEST_CONNECTION, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGTESTCONNECTION");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.testConnectionGraderVending(action.id, action.data);
      if (response.data.success) {
        yield put(actions.testConnectionGraderVendingSuccess());
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.testConnectionGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.testConnectionGraderVendingFail());
    }
  });
}

export function* currentWeightGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_CURRENT_WEIGHT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGCURRENTWEIGHT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.currentWeightGraderVending(action.id, action.data);
      if (response.data.success) {
        yield put(actions.currentWeightGraderVendingSuccess(response.data.data));

        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.currentWeightGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.currentWeightGraderVendingFail());
    }
  });
}

export function* currentSnapshotGraderVending() {
  yield takeEvery(actionTypes.GRADER_VENDING_CURRENT_SNAPSHOT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGCURRENTSNAPSHOT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.currentSnapshotGraderVending(action.id, action.data);
      if (response.data.success) {
        yield put(actions.currentSnapshotGraderVendingSuccess());

        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.currentSnapshotGraderVendingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.currentSnapshotGraderVendingFail());
    }
  });
}

export function* vendingLandfillDistance() {
  yield takeEvery(actionTypes.VENDING_LANDFILL_DISTANCE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGLANDFILLDISTANCE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingLandfillDistance(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.vendingLandfillDistanceSuccess(response.data.data));
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.vendingLandfillDistanceFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingLandfillDistanceFail());
    }
  });
}

export function* audioTTList() {
  yield takeEvery(actionTypes.GRADER_VENDING_AUDIO_TTS_LOAD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGAUDIOTTSLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.audioTTList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.audioTTListSuccess(response.data.data));
        
      } else {
        alert(response.data.message);
        yield put(actions.audioTTListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.audioTTListFail());
    }
  });
}

export function* audioTTSUpdate() {
  yield takeEvery(actionTypes.GRADER_VENDING_AUDIO_TTS_UPDATE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("GRADERVENDINGAUDIOTTSUPD");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.audioTTSUpdate(action.data);
      if (response.data.success) {
        yield put(actions.audioTTSUpdateSuccess());
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.audioTTSUpdateFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.audioTTSUpdateFail());
    }
  });
}

export function* resetMQTTTopic() {
  yield takeEvery(actionTypes.RESET_MQTT_TOPIC, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("RESETMQTTTOPIC");
    action.data.track_no = track_no;

    yield put(actions.enableLoading());

    try {
      const response = yield API.resetMQTTTopic(action.data);
      if (response.data.success) {
        yield put(actions.resetMQTTTopicSuccess());

        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.resetMQTTTopicFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.resetMQTTTopicFail());
    }
  });
}

export function* cancelStuckExpressOrder() {
  yield takeEvery(actionTypes.CANCEL_STUCK_EXPRESS_ORDER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("CANCELSTUCKEXPRESSORDER");
    action.data.track_no = track_no;

    yield put(actions.enableLoading());

    try {
      const response = yield API.cancelStuckExpressOrder(action.id, action.data);
      if (response.data.success) {
        yield put(actions.cancelStuckExpressOrderSuccess());

        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.cancelStuckExpressOrderFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.cancelStuckExpressOrderFail());
    }
  });
}

export function* loadDRVMGradingOrderDashboard() {
  yield takeEvery(actionTypes.LOAD_DRVM_GRADING_ORDER_DASHBOARD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRVMGRADINGORDERDASHBOARD");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDRVMGradingOrderDashboard(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadDRVMGradingOrderDashboardSuccess(response.data.data));
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.loadDRVMGradingOrderDashboardFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDRVMGradingOrderDashboardFail());
    }
  });
}

export function* loadDRVMGradingVendingDashboard() {
  yield takeEvery(actionTypes.LOAD_DRVM_GRADING_VENDING_DASHBOARD, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRVMGRADINGVENDINGDASHBOARD");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDRVMGradingVendingDashboard(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadDRVMGradingVendingDashboardSuccess(response.data.data));
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.loadDRVMGradingVendingDashboardFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDRVMGradingVendingDashboardFail());
    }
  });
}

export function* loadDRVMGradingStatusChart() {
  yield takeEvery(actionTypes.LOAD_DRVM_GRADING_STATUS_CHART, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRVMGRADINGSTATUSCHART");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDRVMGradingStatusChart(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadDRVMGradingStatusChartSuccess(response.data.data));
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.loadDRVMGradingStatusChartFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDRVMGradingStatusChartFail());
    }
  });
}


export function* loadDRVMGradingOrderChart() {
  yield takeEvery(actionTypes.LOAD_DRVM_GRADING_ORDER_CHART, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRVMGRADINGORDERCHART");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDRVMGradingOrderChart(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadDRVMGradingOrderChartSuccess(response.data.data));
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.loadDRVMGradingOrderChartFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDRVMGradingOrderChartFail());
    }
  });
}

export function* loadDRVMGradingRanking() {
  yield takeEvery(actionTypes.LOAD_DRVM_GRADING_RANKING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRVMGRADINGRANKING");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDRVMGradingRanking(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadDRVMGradingRankingSuccess(response.data.data));
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.loadDRVMGradingRankingFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDRVMGradingRankingFail());
    }
  });
}

export function* loadDRVMGradingCategoryChart() {
  yield takeEvery(actionTypes.LOAD_DRVM_GRADING_CATEGORY_CHART, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRVMGRADINGCATEGORYCHART");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDRVMGradingCategoryChart(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadDRVMGradingCategoryChartSuccess(response.data.data));
        
        if(response.data.message)
          yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.loadDRVMGradingCategoryChartFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDRVMGradingCategoryChartFail());
    }
  });
}


/* ===== VENDING COUNCIL ===== */
export function* vendingCouncilList() {
  yield takeEvery(actionTypes.VENDING_COUNCIL_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGCOUNCILLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingCouncilList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.vendingCouncilListSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.vendingCouncilListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingCouncilListFail());
    }
  });
}

export function* vendingCouncilCreate() {
  yield takeEvery(actionTypes.VENDING_COUNCIL_CREATE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGCOUNCILCREATE");

    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingCouncilCreate(action.data);
      if (response.data.success) {
        yield put(actions.vendingCouncilCreateSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.vendingCouncilCreateFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingCouncilCreateFail());
    }
  });
}

export function* vendingCouncilUpdate() {
  yield takeEvery(actionTypes.VENDING_COUNCIL_UPDATE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGCOUNCILUPDATE");

    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingCouncilUpdate(action.id, action.data);
      if (response.data.success) {
        yield put(actions.vendingCouncilUpdateSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.vendingCouncilUpdateFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingCouncilUpdateFail());
    }
  });
}

export function* vendingCouncilRemove() {
  yield takeEvery(actionTypes.VENDING_COUNCIL_REMOVE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGCOUNCILREMOVE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingCouncilRemove(action.id, action.data);
      if (response.data.success) {
        yield put(actions.vendingCouncilRemoveSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.vendingCouncilRemoveFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingCouncilRemoveFail());
    }
  });
}

export function* vendingCouncilSet() {
  yield takeEvery(actionTypes.VENDING_COUNCIL_SET, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGCOUNCILSET");

    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingCouncilSet(action.data);
      if (response.data.success) {
        yield put(actions.vendingCouncilSetSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.vendingCouncilSetFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingCouncilSetFail());
    }
  });
}
/* ===== END VENDING COUNCIL ===== */


/* ===== VENDING VERSION ===== */
export function* vendingVersionList() {
  yield takeEvery(actionTypes.VENDING_VERSION_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGVERSIONLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingVersionList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.vendingVersionListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.vendingVersionListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingVersionListFail());
    }
  });
}

export function* vendingVersionUpload() {
  yield takeEvery(actionTypes.VENDING_VERSION_UPLOAD, function*(action) {

    let track_no = Helper.generateTrackNo("VENDINGVERSIONUPLOAD");
    action.data.append("track_no", track_no);

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingVersionUpload(action.data, action.onUploadProgress);
      if (response.data.success) {
        yield put(actions.vendingVersionUploadSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.vendingVersionUploadFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingVersionUploadFail());
    }
  });
}

export function* vendingVersionSelect() {
  yield takeEvery(actionTypes.VENDING_VERSION_SELECT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGVERSIONSELECT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingVersionSelect(action.id, action.data);
      if (response.data.success) {
        yield put(actions.vendingVersionSelectSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.vendingVersionSelectFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingVersionSelectFail());
    }
  });
}

export function* vendingVersionSend() {
  yield takeEvery(actionTypes.VENDING_VERSION_SEND, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGVERSIONSEND");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingVersionSend(action.id, action.data);
      if (response.data.success) {
        yield put(actions.vendingVersionSendSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.vendingVersionSendFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingVersionSendFail());
    }
  });
}

export function* vendingVersionRemove() {
  yield takeEvery(actionTypes.VENDING_VERSION_REMOVE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("VENDINGVERSIONREMOVE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.vendingVersionRemove(action.id, action.data);
      if (response.data.success) {
        yield put(actions.vendingVersionRemoveSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.vendingVersionRemoveFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.vendingVersionRemoveFail());
    }
  });
}
/* ===== END VENDING VERSION ===== */


/* ===== CATEGORY AI RULES ===== */
export function* loadDRVMRecyclingCategory() {
  yield takeEvery(actionTypes.LOAD_DRVM_RECYCLING_CATEGORY, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DRVMCATEGORYLOAD");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadDRVMRecyclingCategory(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadDRVMRecyclingCategorySuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadDRVMRecyclingCategoryFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadDRVMRecyclingCategoryFail());
    }
  });
}

export function* updateCategoryRules() {
  yield takeEvery(actionTypes.UPDATE_CATEGORY_RULES, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("CATEGORYRULESUPDATE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.updateCategoryRules(action.id, action.data);
      if (response.data.success) {
        yield put(actions.updateCategoryRulesSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.updateCategoryRulesFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updateCategoryRulesFail());
    }
  });
}
/* ===== END CATEGORY AI RULES ===== */

export default function* vendingSaga() {
  
  
  yield all([fork(loadVendingCategory)]);
  yield all([fork(loadVendingCategoryAll)]);
  yield all([fork(addVendingCategory)]);
  yield all([fork(editVendingCategory)]);
  yield all([fork(deleteVendingCategory)]);
  
  yield all([fork(loadVendingCategoryEffectiveDateList)]); 
  yield all([fork(vendingCategoryPriceControlLoad)]);
  yield all([fork(vendingCategoryPriceControlSet)]);  
  yield all([fork(vendingCategoryPriceRemove)]);
  yield all([fork(getVendingCategoryPricePDF)]);

  yield all([fork(graderVendingCount)]);
  yield all([fork(loadGraderVendingList)]);
  yield all([fork(loadGraderVendingLocationList)]);
  yield all([fork(loadGraderVendingBagList)]);
  yield all([fork(vendingBagCount)]);
  yield all([fork(vendingBagRollbackOverflow)]);
  yield all([fork(vendingBagConfirmTripFilling)]);
  yield all([fork(vendingBagForceTripFilling)]);
  yield all([fork(graderVendingDeviceStatusList)]);
  yield all([fork(graderVendingUploadedLogsList)]);
  yield all([fork(errorLogsResolved)]);
  yield all([fork(graderVendingDetail)]);
  yield all([fork(approveGraderVending)]);
  yield all([fork(addGraderVending)]);
  yield all([fork(editGraderVending)]);
  yield all([fork(resetPwdGraderVending)]);
  yield all([fork(deleteGraderVending)]);
  yield all([fork(publishGraderVending)]);
  yield all([fork(residentOnlyGraderVending)]);
  yield all([fork(rebootGraderVending)]);
  yield all([fork(unlockMaglockGraderVending)]);
  yield all([fork(currentStatusGraderVending)]);
  yield all([fork(controlBoardGraderVending)]);
  yield all([fork(stopGraderVending)]);
  yield all([fork(startGraderVending)]);
  yield all([fork(testConnectionGraderVending)]);
  yield all([fork(currentWeightGraderVending)]);
  yield all([fork(currentSnapshotGraderVending)]);
  yield all([fork(vendingLandfillDistance)]);
  yield all([fork(audioTTList)]);
  yield all([fork(audioTTSUpdate)]);
  yield all([fork(resetMQTTTopic)]);
  yield all([fork(cancelStuckExpressOrder)]);
  yield all([fork(loadDRVMGradingOrderDashboard)]);
  yield all([fork(loadDRVMGradingVendingDashboard)]);
  yield all([fork(loadDRVMGradingStatusChart)]);
  yield all([fork(loadDRVMGradingOrderChart)]);
  yield all([fork(loadDRVMGradingRanking)]);
  yield all([fork(loadDRVMGradingCategoryChart)]);

  yield all([fork(vendingCouncilList)]);
  yield all([fork(vendingCouncilCreate)]);
  yield all([fork(vendingCouncilUpdate)]);
  yield all([fork(vendingCouncilRemove)]);
  yield all([fork(vendingCouncilSet)]);

  yield all([fork(vendingVersionList)]);
  yield all([fork(vendingVersionUpload)]);
  yield all([fork(vendingVersionSelect)]);
  yield all([fork(vendingVersionSend)]);
  yield all([fork(vendingVersionRemove)]);

  yield all([fork(loadDRVMRecyclingCategory)]);
  yield all([fork(updateCategoryRules)]);
}
